import angular from 'angular';
export default angular.module('shared').component('asuiFormComponent', {
    template: require('./asuiFormComponent.component.html'),
    styleUrls: require('./asuiFormComponent.component.css'),
    controller: [asuiFormComponent],
    bindToController: true,
    bindings: {
        item: '<',
        form: '<',
        items: '<'
    }
});

function asuiFormComponent() {
    var vm = this;
    vm.$onInit = init;
    function init() {
        vm.validation = {};
        if (vm.item.validation) {
            if (vm.item.validation.required) {
                vm.validation.required = vm.item.validation.required.value;
            }

            if (vm.item.validation.minlength) {
                vm.validation.minlength = vm.item.validation.minlength.value;
            }

            if (vm.item.validation.maxlength) {
                vm.validation.maxlength = vm.item.validation.maxlength.value;
            }
        }

        if (vm.item.show === undefined) {
            vm.item.show = function() {
                return true;
            };
        }

        vm.maxsize = function() {
            if (!vm.form[vm.item.name]) {
                return false;
            }

            var maxsize =
                vm.item.file &&
                vm.item.file.size > vm.item.validation.maxsize.value
                    ? true
                    : false;
            vm.form[vm.item.name].$setValidity('maxsize', !maxsize);
            return maxsize;
        };
    }
}



// WEBPACK FOOTER //
// ./modules/shared/components/asui-form-component/asuiFormComponent.component.js